import React from 'react';
import { isEmpty } from 'lodash';

import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';
import FileCopyIcon from '@material-ui/icons/FileCopyRounded';
import Tooltip from '@material-ui/core/Tooltip';

import { getItemTypes } from '../../common/items';

import styles from './Item.module.scss';
import ACButton from '../../atoms/ACButton';
import { Checkbox } from '@material-ui/core';

export default class Item extends React.Component {
  constructor(props) {
    super(props);

    this.onClickClone = this.onClickClone.bind(this);
  }

  // componentDidUpdate() {
  //   console.log('itemComponentDidUpdate', this.props.selected, this.props.item.id)
  //   // this.setState({
  //   //   isChecked: this.props.selected
  //   // })
  // }

  componentDidUpdate(prevProps) {
    // console.log(prevProps, this.props, 'itemComponentDidUpdate');
  if (prevProps.selected !== this.props.selected) {
    // console.log(`Item ${this.props.item.id} previous: ${prevProps.selected},  updated:`, this.props.selected);
  }
}

  onClickClone(e, item) {
    this.props.onCloneItemFunc(item);
    e.stopPropagation();
  }

  renderItemType() {
    let { item = { type: '' } } = this.props;
    let itemTypeName = '';

    const findItemType = getItemTypes().find(iType => {
      return iType.value === item.type;
    });

    if (!isEmpty(findItemType)) {
      itemTypeName = findItemType.name;
    }

    if (!isEmpty(itemTypeName)) {
      return (
        <Tooltip title={itemTypeName}>
          <div className={styles.itemType}>
            <ACButton
              text={itemTypeName}
              backgroundColor={'#616161'}
              spanMargin="0 0"
              color={'white'}
            />
          </div>
        </Tooltip>
      );
    } else return null;
  }
  render() {
    let { item, currencySymbol } = this.props;
    let suitables = item.suitables || [];
    let dietaries = item.dietaries || {};

    let dietariesComponents = [];
    if (dietaries.vegan) {
      dietariesComponents.push('VG');
    }
    if (dietaries.vegetarian) {
      dietariesComponents.push('V');
    }
    if (dietaries.glutenFree) {
      dietariesComponents.push('GF');
    }

  

    let suitableComponents = [];
    if (suitables) {
      suitables.forEach(s => {
        if (s.adults || s.children) {
          suitableComponents.push(
            <div>
              <Chip
                label={s.adults}
                style={{
                  backgroundColor: 'black',
                  borderColor: 'black',
                  color: 'white',
                  fontSize: '12px',
                }}
              />
              {
                s.children && (
                  <Chip
                    label={s.children}
                    style={{
                      backgroundColor: 'white',
                      borderColor: 'black',
                      color: 'black',
                      fontSize: '12px',
                      borderStyle: 'solid'
                    }}
                  />
                )
              }
            </div>
          );
        }
      });
    }

    const price = item.price ? item.price.toFixed(2) : '';
    let rootStyle = [styles.root];

    if (!isEmpty(item.subItems)) rootStyle.push(styles.hasSubItems);

    return (
      <ListItem className={rootStyle.join(' ')}>
        {
          item.status === 'active' && this.props.isBulkEditModeOn && (
            <div>
                <Checkbox className={styles.itemSelect} key={`${this.props.item.id}-${this.props.selected}`} color="primary" checked={this.props.selected} onChange={() => {
                  this.props.onItemSelectFunc(item.id)
                }} />
            </div>
          )
        }
        <div  onClick={() => this.props.onClickItemFunc(item)} className={styles.item}>
          <div className={styles.itemName}>
            <span className={styles.boldFont}>{item.name}</span>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.cost}>
              <span className={styles.boldFont}>Cost</span>
              <span>
              {currencySymbol}
              {price}
              </span>
            </div>
            {this.renderItemType()}
            <div className={styles.itemSuitables}>{suitableComponents}</div>
            <div className={styles.dietariesComponents}>
              {
                dietariesComponents.map(i => i).join(' / ')
              }
            </div>
            <div style={{marginLeft: 'auto'}}>
              <ACButton
                style={{padding: 0}}
                text="Clone"
                onClickFunc={e => this.onClickClone(e, item)}
                icon={<FileCopyIcon />}
                padding='0'
              />
            </div>
          </div>
        </div>
      </ListItem>
    );
  }
}
